import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { StyledWrapper } from './HomeButton.styled';
import { baseUrl } from '../../config/baseUrl';

const HomeButton = (props) => {
  const { onClick } = props;
  return (
    <StyledWrapper>
      <Link to={baseUrl} onClick={onClick}>
        <img src={`${baseUrl}img/logobk.png`} alt='logo' width={32} height={32} />
      </Link>
    </StyledWrapper>
  );
};

HomeButton.propTypes = {
  onClick: PropTypes.func,
};

export default HomeButton;
